let guideArray = document.getElementsByClassName('guide-column__box-wrap');
let headersArray = document.getElementsByClassName('guide-headers__header');
let descriptionArray = document.getElementsByClassName('guide-description');
let prodVariable = '';
let guideVariable = '';
let tipTriggers = document.getElementsByClassName('top-tips__more');
let topTips = document.getElementsByClassName('top-tips__content');
let trigger = '';
let repairAlt = ['strength', 'curing', 'pack', 'coverage'];

for (var i = 0; i < guideArray.length; i++) {
    for (var x = 1; x < headersArray.length; x++) {
      
      	
        let color = '';
      	let variableText = '';
        let noTick = false;
      	let alternateValue = false;
      

		
      	guideVariable = headersArray[x].getAttribute('data-variable');
        prodVariables = descriptionArray[i].getAttribute('data-guide');
		
      
        for (var y = 0; y < repairAlt.length; y++) {

          console.log(guideVariable);

        	if ( guideVariable == repairAlt[y] ) {
				alternateValue = true;
        	}
        }
                
        if (guideVariable == 'slip') {
            color = 'amber'
        };
      
        if (alternateValue == true) {
            noTick = true;
          	if(descriptionArray[i].hasAttribute('data-'+guideVariable)) {
          		variableText = descriptionArray[i].getAttribute('data-'+guideVariable);
        	}
        };
        if (prodVariables.includes(guideVariable)) {
          if (noTick == true) {
                guideArray[i].innerHTML +=
                '<div class="guide-column__box" data-variable="' + guideVariable + '">' +
                '<p>'+variableText+'</p>' +
                '</div>';
          } else {
            	guideArray[i].innerHTML +=
                '<div class="guide-column__box" data-variable="' + guideVariable + '">' +
                '<i class="fas fa-check ' + color + '"></i>' +
                '</div>';
          }
        } else {
            guideArray[i].innerHTML +=
                '<div class="guide-column__box" data-variable="' + guideVariable + '">' +
                '<i class="fas fa-times"></i>' +
                '</div>';
        }
    }
}

for (var i = 0; i < tipTriggers.length; i++) {

    tipTriggers[i].addEventListener("click", function() {
        console.log('click')
        target = this.getAttribute('data-trigger');
        // resetTips();
        // document.getElementById(target).style.display = 'block';
        if (this.classList.contains('expanded')) {
            document.getElementById(target).style.cssText = "height: 0px; opacity: 0;";
            this.classList.remove('expanded');
        } else {
            document.getElementById(target).style.cssText = "height: 170px; opacity: 1;";
            this.classList.add('expanded');

        }
    })

}

function resetTips() {
    for (var i = 0; i < topTips.length; i++) {
        topTips[i].style.display = 'none'
    }
}